// The words for each destructive action, kept in one place so the same action asks the same way
// wherever it starts: a menu, an info page or a thread. Every one goes through the one confirm
// sheet in Feedback.tsx.

export type ConfirmAsk = { title: string; detail: string; action: string };

/** Deleting a message for everyone, in a chat, a channel or a thread. */
export function deleteMessageAsk(where: "chat" | "channel" | "thread"): ConfirmAsk {
  return {
    title: "Delete this message?",
    detail: `It will be removed for everyone in this ${where}. This cannot be undone.`,
    action: "Delete for everyone",
  };
}

/** Leaving a group, from its menu or its info page. */
export function leaveGroupAsk(title: string): ConfirmAsk {
  return {
    title: `Leave ${title}?`,
    detail: "You stop getting its messages. An admin can add you back.",
    action: "Leave group",
  };
}

/** An admin removing someone from a group. */
export function removeFromGroupAsk(name: string, group: string): ConfirmAsk {
  return {
    title: `Remove ${name}?`,
    detail: `They leave ${group} and stop getting its messages. An admin can add them back.`,
    action: "Remove",
  };
}

/** Delete for me: the messages leave your devices and stay for everyone else. */
export function deleteForMeAsk(count = 1): ConfirmAsk {
  const one = count === 1;
  return {
    title: one ? "Delete this message for you?" : `Delete ${count} messages for you?`,
    detail: `${one ? "It is" : "They are"} removed from all your devices. Others in the chat keep ${one ? "it" : "them"}.`,
    action: "Delete for me",
  };
}
